import { defineComponent as C, createVNode as n } from "vue";
import c from "../Modal.vue.js";
/* empty css            */
const v = /* @__PURE__ */ C({
  components: {
    Modal: c
  },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    overlay: {
      type: Boolean,
      default: !0
    },
    radius: {
      type: Boolean,
      default: !0
    },
    overlayClass: {
      type: String
    },
    dialogClass: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    message: String,
    showConfirmButton: {
      type: Boolean,
      default: !0
    },
    showCancelButton: {
      type: Boolean,
      default: !1
    },
    confirmButtonText: {
      type: String,
      default: "Confirm"
    },
    cancelButtonText: {
      type: String,
      default: "Cancel"
    },
    allowHtml: Boolean,
    callback: Function
  },
  emits: ["update:visible", "confirm", "cancel"],
  setup(t, {
    emit: l,
    slots: a
  }) {
    const s = (e) => l("update:visible", e), u = (e) => {
      s(!1), t.callback && t.callback(e);
    }, o = (e) => () => {
      t.visible && (l(e), u(e));
    }, r = o("cancel"), d = o("confirm"), f = () => {
      const e = a.title ? a.title() : t.title;
      if (e)
        return n("div", {
          class: "a-dialog__header"
        }, [e]);
    }, m = () => {
      if (a.default)
        return n("div", {
          class: "a-dialog__content"
        }, [a.default()]);
      const {
        message: e,
        allowHtml: b
      } = t;
      if (e) {
        const i = e;
        return b && typeof i == "string" ? n("div", {
          class: "a-dialog__content",
          innerHTML: i
        }, null) : n("div", {
          class: "a-dialog__content"
        }, [e]);
      }
    }, g = () => {
      if (t.showConfirmButton || t.showCancelButton)
        return n("div", {
          class: "a-dialog__footer"
        }, [t.showCancelButton && n("button", {
          type: "button",
          class: "a-mobile-btn a-mobile-btn--default a-mobile-btn--large a-dialog__cancel",
          onClick: r
        }, [t.cancelButtonText]), t.showConfirmButton && n("button", {
          type: "button",
          class: "a-mobile-btn a-mobile-btn--default a-mobile-btn--large a-dialog__confirm",
          onClick: d
        }, [t.confirmButtonText])]);
    };
    return () => {
      const e = "a-dialog" + (t.dialogClass ? " " + t.dialogClass : "") + (t.radius ? " a-dialog--radius" : "");
      return n(c, {
        open: t.visible,
        className: e,
        position: "center"
      }, {
        default: () => [f(), m(), g()]
      });
    };
  }
});
export {
  v as default
};
